import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	triggerOuter: {
		position: 'relative',
		display: 'inline-flex',
		alignItems: 'stretch',
	},
	trigger: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		minWidth: 240,
		width: '100%',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: THEME.typography.fontSizes.sm,
		background: THEME.colors.background.light,
		color: THEME.colors.text.main,
		cursor: 'pointer',
		textAlign: 'left',
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: 1,
		},
	},
	triggerHasClear: {
		paddingRight: 32,
	},
	triggerSm: {
		height: 36,
		padding: `0 ${THEME.spacing.md}px`,
	},
	triggerLabel: {
		flexGrow: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	triggerLabelMuted: {
		color: THEME.colors.text.light,
	},
	clear: {
		position: 'absolute',
		right: 8,
		top: '50%',
		transform: 'translateY(-50%)',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 18,
		height: 18,
		borderRadius: '50%',
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1,
		color: THEME.colors.text.light,
		cursor: 'pointer',
		background: 'transparent',
		border: 'none',
		padding: 0,
		':hover': {
			background: THEME.colors.background.main,
			color: THEME.colors.text.main,
		},
	},
	popoverContent: {
		padding: 0,
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
});
